module.exports = __webpack_public_path__ + "static/media/avatar-19.bdbe9fc3.svg";